import React, { useState, useEffect } from 'react';  
  import "./Kpidetails.css";  
  import { useNavigate } from "react-router-dom";  
   
  export function KPIDashboard() {  
      const [startDate, setStartDate] = useState('');  
      const [endDate, setEndDate] = useState('');  
      const [KPIData, setKPIData] = useState({});  
      const [isLoading, setIsLoading] = useState(false);  
      const [submittedRange, setSubmittedRange] = useState(null);  
      const [uniqueUserNames, setUniqueUserNames] = useState([]);  
      const [selectedUser, setSelectedUser] = useState('');  
   
      useEffect(() => {  
          const handleScroll = () => {  
              const footer = document.querySelector('footer');  
              if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {  
                  footer.style.display = 'block';  
              } else {  
                  footer.style.display = 'none';  
              }  
          };  
   
          window.addEventListener('scroll', handleScroll);  
          return () => {  
              window.removeEventListener('scroll', handleScroll);  
          };  
      }, []);  
   
      const fetchKPIData = async (start, end, user = '') => {  
          setIsLoading(true);  
          try {  
              const response = await fetch(`/api/kpidetails`, {  
                  method: 'POST',  
                  headers: {  
                      'Content-Type': 'application/json',  
                  },  
                  body: JSON.stringify({ start, end, user }),  
              });  
              const result = await response.json();  
              setKPIData(result);  
              setUniqueUserNames(result.uniqueUserNames || []);  
          } catch (error) {  
              console.error('Error fetching data:', error);  
          } finally {  
              setIsLoading(false);  
          }  
      };  
   
      const handleSubmitDateRange = () => {  
          if (startDate && endDate) {  
              console.log(`Fetching KPI details from ${startDate} to ${endDate}`);  
              setSubmittedRange(`${startDate} - ${endDate}`);  
              fetchKPIData(startDate, endDate);  
          } else {  
              alert('Please select both start and end dates.');  
          }  
      };  
   
      const handleUserChange = (e) => {  
          const user = e.target.value;  
          setSelectedUser(user);  
          if (startDate && endDate && user) {  
              console.log(`Fetching KPI details for user ${user} from ${startDate} to ${endDate}`);  
              setSubmittedRange(`${startDate} - ${endDate} | User: ${user}`);  
              fetchKPIData(startDate, endDate, user);  
          }  
      };  
   
      return (  
  <>  
    <h1>Analytics Dashboard</h1>  
    <div className="container_KPI">  
      <div className="left-container_KPI">  
        {/* Date Picker and User Dropdown */}  
        <div className="datepickercontainer_KPI">  
          <div className="date-picker_KPI">  
            <div className="startdate_KPI">  
              <label htmlFor="start-date-picker">Start date:</label>  
              <input  
                type="date"  
                id="start-date-picker"  
                name="start-date-picker"  
                value={startDate}  
                onChange={(e) => setStartDate(e.target.value)}  
              />  
            </div>  
            <div className="enddate_KPI">  
              <label htmlFor="end-date-picker">End date:</label>  
              <input  
                type="date"  
                id="end-date-picker"  
                name="end-date-picker"  
                value={endDate}  
                onChange={(e) => setEndDate(e.target.value)}  
              />  
            </div>  
          </div>  
          <button onClick={handleSubmitDateRange}>Submit</button>  
        </div>  
        <div className="user-dropdown_KPI">  
          <select  
            id="unique-user-dropdown"  
            name="unique-user-dropdown"  
            value={selectedUser}  
            onChange={handleUserChange}  
          >  
            <option value="">Select a unique user</option>  
            {uniqueUserNames.length > 0 ? (  
              uniqueUserNames.map((name, index) => (  
                <option key={index} value={name}>  
                  {name}  
                </option>  
              ))  
            ) : (  
              <option value="">No unique users available</option>  
            )}  
          </select>  
        </div>  
        {selectedUser && (  
          <div className="table-section">  
            <h2>User Metrics for {selectedUser}</h2>  
            <table className="table_KPI">  
              <thead>  
                <tr>  
                  <th>User Metric</th>  
                  <th>User Value</th>  
                </tr>  
              </thead>  
              <tbody>  
                <tr>  
                  <td>{selectedUser} Accessing Knowledge Articles</td>  
                  <td>  
                    {KPIData.uniqueUserHits !== undefined  
                      ? KPIData.uniqueUserHits  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Tickets Created by {selectedUser}</td>  
                  <td>  
                    {KPIData.userTicketsCreated !== undefined  
                      ? KPIData.userTicketsCreated  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Tickets Updated by {selectedUser}</td>  
                  <td>  
                    {KPIData.userTicketsUpdated !== undefined  
                      ? KPIData.userTicketsUpdated  
                      : "N/A"}  
                  </td>  
                </tr>  
              </tbody>  
            </table>  
          </div>  
        )}  
      </div>  
 
      <div className="right-container_KPI">  
        <div className="table-row">  
          <div className="table-section">  
            <h2>Bot Adoption</h2>  
            <table className="table_KPI">  
              <tbody>  
                <tr>  
                  <td>Current User Base</td>  
                  <td>  
                    {KPIData.totalSessions !== undefined ? 242 : "N/A"}
                </td>  
                </tr>  
                <tr>  
                  <td>Unique Users</td>  
                  <td>  
                    {KPIData.uniqueUsers !== undefined  
                      ? KPIData.uniqueUsers  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Adoption Rate</td>  
                  <td>  
                    {KPIData.Adoption_Rate !== undefined  
                      ? `${KPIData.Adoption_Rate.toFixed(2)}%`  
                      : "N/A"}  
                  </td>  
                </tr>  
              </tbody>  
            </table>  
          </div>  
 
          <div className="table-section">  
            <h2>Bot ITSM Ticket Handling</h2>  
            <table className="table_KPI">  
              <tbody>  
                <tr>  
                  <td>Incidents Created</td>  
                  <td>  
                    {KPIData.ticketsCreated !== undefined  
                      ? KPIData.ticketsCreated  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Incidents Updated</td>  
                  <td>  
                    {KPIData.ticketsUpdated !== undefined  
                      ? KPIData.ticketsUpdated  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Service Request Updated</td>  
                  <td>  
                    {KPIData.ServiceRequestUpdated !== undefined  
                      ? KPIData.ServiceRequestUpdated  
                      : "N/A"}  
                  </td>  
                </tr>
                {/* <tr>  
                  <td>User Resolved Incidents</td>  
                  <td>  
                    {KPIData.ticketsResolved !== undefined  
                      ? KPIData.ticketsResolved  
                      : "N/A"}  
                  </td>  
                </tr> 
                <tr>  
                  <td>Reopened Incidents</td>  
                  <td>  
                    {KPIData.ticketsReopened !== undefined  
                      ? KPIData.ticketsReopened  
                      : "N/A"}  
                  </td>  
                </tr>  */}
                <tr>  
                  <td>Incident Status Check</td>  
                  <td>  
                    {KPIData.TicketStatus !== undefined  
                      ? KPIData.Ticketstatuscount  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Service Request Status Check</td>  
                  <td>  
                    {KPIData.RequestStatus !== undefined  
                      ? KPIData.RequestStatuscount 
                      : "N/A"}  
                  </td>  
                </tr>  
              </tbody>  
            </table>  
          </div>  
        </div>  
 
        <div className="table-section">  
          <h2>Bot Effectiveness</h2>  
          <div className="bot-effectiveness-section">  
            <div className="effectiveness-metrics">  
              {/* Group 1 */}  
              <div className="metric">  
                <div className="metric-title">Total Sessions</div>  
                <div className="metric-value">  
                  {KPIData.totalSessions !== undefined  
                    ? KPIData.totalSessions  
                    : "N/A"}  
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">Agent Transfers</div>  
                <div className="metric-value">  
                  {KPIData.agentTransfers !== undefined  
                    ? KPIData.agentTransfers  
                    : "N/A"}  
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">Void Sessions</div>  
                <div className="metric-value">  
                  {KPIData.Void !== undefined ? KPIData.Void : "N/A"}  
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">Chats Handled</div>  
                <div className="metric-value">  
                  {KPIData.chatsHandled !== undefined  
                    ? `${KPIData.chatsHandled}%`  
                    : "N/A"}  
                </div>  
              </div>  
            </div>  

            <div className="effectiveness-metrics">  
              {/* Group 2 */}  
              {/* <div className="metric">  
                <div className="metric-title">Status Check Incident</div>  
                <div className="metric-value">  
                   {KPIData.TicketStatus !== undefined  
                      ? KPIData.TicketStatus  
                      : "N/A"}
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">Status Check Service Request</div>  
                <div className="metric-value">  
                  {KPIData.RequestStatus !== undefined? KPIData.RequestStatus : "NA"}
                </div>  
              </div>   */}


              {/* <div className="metric">  
                <div className="metric-title">Accuracy</div>  
                <div className="metric-value">  
                  {KPIData.accuracy !== undefined  
                    ? `${KPIData.accuracy}%`  
                    : "N/A"}  
                </div>  
              </div>   */}
            </div>  
 
            <div className="effectiveness-metrics">  
              {/* Group 3 */}  
              {/* <div className="metric">  
                <div className="metric-title">Positive Feedback</div>  
                <div className="metric-value">  
                  {KPIData.positiveFeedbacks !== undefined  
                    ? KPIData.positiveFeedbacks  
                    : "N/A"}  
                </div>  
              </div>   */}
              {/* <div className="metric">  
                <div className="metric-title">Negative Feedback</div>  
                <div className="metric-value">  
                  {KPIData.negativeFeedbacks !== undefined  
                    ? KPIData.negativeFeedbacks  
                    : "N/A"}  
                </div>  
              </div>   */}
              {/* <div className="metric">  
                <div className="metric-title">CSAT</div>  
                <div className="metric-value">  
                  {KPIData.csat !== undefined ? `${KPIData.csat}%` : "N/A"}  
                </div>  
              </div>   */}
            </div>  
          </div>  
        </div>  

        <div className="table-section">  
          <h2>KB Effectiveness</h2>  
          <div className="effectiveness-metrics">  
              {/* Group 2 */}  
              <div className="metric">  
                <div className="metric-title">KB Queries Answered</div>  
                <div className="metric-value">  
                  {KPIData.KMBotInfoAnswred !== undefined  
                    ? KPIData.KMBotInfoAnswred  
                    : "N/A"}  
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">KB Queries UnAnswered</div>  
                <div className="metric-value">  
                  {KPIData.KMBotInfoUnAnswred !== undefined  
                    ? KPIData.KMBotInfoUnAnswred  
                    : "N/A"}  
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">KB Accuracy</div>  
                <div className="metric-value">  
                  {KPIData.accuracy !== undefined  
                    ? `${KPIData.accuracy}%`  
                    : "N/A"}  
                </div>  
              </div>  
            </div>  
        </div>  

      </div>  
    </div>  
    <footer></footer>  
  </>  
);  
  }